import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";
import { fetchArticles, createArticle, deleteArticle } from "../../lib/api";

export default function AdminArticles() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", excerpt: "", body: "", cover: "", author: "Editorial", featured: false });

  const reload = () => fetchArticles({ limit: 100 }).then(setItems).catch(() => {});
  useEffect(() => { reload(); }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.body) return toast.error("Title and body are required");
    try {
      await createArticle(form);
      toast.success("Article published");
      setForm({ title: "", excerpt: "", body: "", cover: "", author: "Editorial", featured: false });
      reload();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
  };

  return (
    <div data-testid="admin-articles-page" className="space-y-10">
      <div>
        <div className="overline text-[#B79C7B]">Editorial</div>
        <h1 className="font-serif text-4xl text-ivory mt-2">News & Articles</h1>
      </div>

      <section className="border border-[#2A2A2D] bg-[#121214] p-8">
        <div className="overline text-[#B79C7B] mb-6">Write new article</div>
        <form onSubmit={onSubmit} className="grid md:grid-cols-2 gap-4">
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory md:col-span-2" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="article-title" />
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory" placeholder="Author" value={form.author} onChange={(e) => setForm({ ...form, author: e.target.value })} data-testid="article-author" />
          <input className="h-11 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory" placeholder="Cover image URL" value={form.cover} onChange={(e) => setForm({ ...form, cover: e.target.value })} data-testid="article-cover" />
          <textarea className="md:col-span-2 min-h-[80px] bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 py-3 text-ivory" placeholder="Excerpt" value={form.excerpt} onChange={(e) => setForm({ ...form, excerpt: e.target.value })} data-testid="article-excerpt" />
          <textarea className="md:col-span-2 min-h-[180px] bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 py-3 text-ivory" placeholder="Body (Markdown plain text)" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="article-body" />
          <label className="flex items-center gap-2 text-sm text-[#A1A1AA] h-11 px-4 border border-[#2A2A2D] bg-[#0A0A0B] md:col-span-2">
            <input type="checkbox" checked={form.featured} onChange={(e) => setForm({ ...form, featured: e.target.checked })} data-testid="article-featured" />
            Feature on home page
          </label>
          <button type="submit" className="md:col-span-2 h-11 bg-[#8A2E2E] hover:bg-[#A33B3B] text-sm tracking-widest flex items-center justify-center gap-2" data-testid="publish-article-button">
            <Plus size={16} /> PUBLISH
          </button>
        </form>
      </section>

      <section>
        <div className="overline text-[#B79C7B] mb-4">All articles · {items.length}</div>
        <div className="border border-[#2A2A2D]">
          {items.map((a) => (
            <div key={a.id} className="flex items-center justify-between px-5 py-4 border-b border-[#2A2A2D]" data-testid={`article-row-${a.id}`}>
              <div className="min-w-0">
                <div className="text-ivory truncate">{a.title}</div>
                <div className="text-xs text-[#71717A] truncate">{a.author} · {new Date(a.published_at).toLocaleDateString()}</div>
              </div>
              <button onClick={async () => { await deleteArticle(a.id); reload(); }} className="text-[#71717A] hover:text-[#FF3B30]" data-testid={`delete-article-${a.id}`}>
                <Trash size={14} />
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
